import Vue from 'vue'
import { store } from './store'
import router from './router'
import 'babel-polyfill'

// plugins
import veeValidate from './plugins/veeValidate'
import vuetify from './plugins/vuetify'
import { i18n } from './plugins/i18n'
import gtm from './plugins/gtm'
import moment from 'moment'
import 'moment-timezone'
import 'animate.css'
import axios from 'axios'

import App from './App'

window.moment = moment
moment.locale('zh-tw')
moment.tz.setDefault('Asia/Taipei')

Vue.use(vuetify)
Vue.use(veeValidate)
Vue.use(gtm)
Vue.config.productionTip = false
Vue.config.performance = true

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    // 取得 版號 等環境變數
    axios.get('/api/v1/env')
      .then(response => {
        store.commit('SET_ENV_DATA', response.data ? response.data : null)
      })
      .catch(() => {})
  }
}).$mount('#app')
